module.exports = __webpack_public_path__ + "static/media/ebay.220d54e3.svg";